
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/playing-fair-how-we-do-prize-draws",
      function () {
        return require("private-next-pages/blog/playing-fair-how-we-do-prize-draws.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/playing-fair-how-we-do-prize-draws"])
      });
    }
  